<template>
  <div class="course-detail">
    <div class="cd-body">
      <img class="cd-cover" :src="detail.cover_img" />
      <div class="cd-info">
        <p class="info-title">{{detail.title}}</p>
        <!-- 非面授 -->
        <div v-if="detail.course_type != 7">
          <p class="info-com">共{{detail.total_periods}}课时 | {{detail.sales_num}}人已报名</p>
          <p
            v-if="$pub.showPlayType(detail.course_type)"
            class="info-com"
          >开课时间：{{detail.start_play_date | fomartTime('yyyy/MM/dd hh:mm')}} - {{detail.end_play_date | fomartTime('yyyy/MM/dd hh:mm')}}</p>
        </div>
        <!-- 面授 -->
        <div style="padding-top: 1.33333vw;" v-else>
          <p
            class="info-com"
            v-if="detail.store_num < 999999"
          >报名上限：{{detail.store_num}}人 | 剩余名额：{{detail.stock}}</p>
          <p class="info-com">报名截止时间：{{detail.enter_end_date | fomartTime('yyyy.MM.dd hh:mm')}}</p>
          <p
            class="info-com"
          >开课时间：{{detail.start_play_date | fomartTime('yyyy/MM/dd hh:mm')}} - {{detail.end_play_date | fomartTime('yyyy/MM/dd hh:mm')}}</p>
          <p class="info-com">开课地点：{{detail.province_name + detail.district_name +detail.address}}</p>
        </div>
        <p class="info-price" v-if="!detail.is_free">
          <icon-price style="color: #999" size="mini" v-if="detail.underlined_price"></icon-price>
          <font
            v-if="detail.underlined_price"
            class="underline"
          >{{detail.underlined_price | toFixPrice}}</font>
          <icon-price></icon-price>
          <font>{{detail.price | toFixPrice}}</font>
        </p>
        <p class="info-price cd-free" v-else>免费</p>
      </div>
      <group-info v-if="is_active" :info="group_info" comType="course_detail"></group-info>
      <div
        class="cd-actives"
        v-if="couponList.length && !is_active || couponList.length && is_active && group_info.is_use_coupon == 1 || detail.is_vip_course || detail.service.length"
      >
        <section>
          <div
            class="actives-item"
            v-if="couponList.length && !is_active || couponList.length && is_active && group_info.is_use_coupon == 1"
            @click="getCoupon"
          >
            <span>优惠：</span>
            <span>
              <em>领取优惠券最多可减</em>
              <icon-price size="mini"></icon-price>
              <i>{{max_price | toFixPrice(0)}}</i>
            </span>
            <font>领取</font>
          </div>
          <div class="actives-item" v-if="detail.is_vip_course" @click="goVip">
            <span>会员：</span>
            <span
              v-if="detail.is_vip_user"
            >您的会员到期日为：{{detail.vip_user_end | fomartTime('yyyy.MM.dd')}}</span>
            <span v-else>免费观看</span>
            <font>{{detail.is_vip_user?'续费':'开通'}}</font>
          </div>
          <div class="actives-item" @click="openServer" v-if="detail.service.length">
            <span>服务：</span>
            <span>
              <span
                v-for="(item,index) in detail.service"
                :key="index"
              >{{item.name}}{{ index+1 != detail.service.length ? ' / ':''}}</span>
            </span>
            <font>详情</font>
          </div>
        </section>
      </div>
      <group v-if="is_active" :list="group_list" :info="group_info" @updataList="getGroupInfo"></group>
      <div class="cd-teachers com-style" v-if="teachers.length">
        <p class="cd-title">教学团队</p>
        <ul>
          <li @click="goTeacher(item.teacher_id)" v-for="(item,index) in teachers" :key="index">
            <img :src="item.teacher_avatar" />
            <span>{{item.teacher_name}}</span>
          </li>
        </ul>
      </div>
      <!-- 导航 -->
      <div class="header" id="nav-head" v-if="detail.course_type != 9">
        <header :class="{'fixed-sty': fix}">
          <div class="h-title">
            <p>
              <span :class="{'active':active=='tro'}" @click="scrollTo('tro')">课程介绍</span>
              <span :class="{'active':active=='list'}" @click="scrollTo('list')">课程大纲</span>
              <span :class="{'active':active=='com'}" @click="scrollTo('com')">课程评价</span>
            </p>
          </div>
        </header>
      </div>
      <div class="header" id="nav-head" v-else>
        <header :class="{'fixed-sty': fix}">
          <div class="h-title">
            <p>
              <span :class="{'active':active=='list'}" @click="scrollTo('list')">包含内容</span>
              <span :class="{'active':active=='tro'}" @click="scrollTo('tro')">课程介绍</span>
            </p>
          </div>
        </header>
      </div>
      <div id="list" class="cd-list com-style" v-if="detail.course_type == 9">
        <p class="cd-title">包含内容</p>
        <course-item :course="courses" :itemStyle="true" system="1"></course-item>
      </div>
      <div id="tro" class="cd-tro">
        <p class="cd-title">课程介绍</p>
        <div class="cd-details" v-html="detail.course_details"></div>
      </div>
      <div id="list" class="cd-list com-style" v-if="detail.course_type != 9">
        <p class="cd-title">课程大纲</p>
        <charpter :charpters="list" :detail="detail"></charpter>
      </div>
      <div id="com" class="cd-comment com-style" v-if="detail.course_type != 9">
        <p class="cd-title">课程评论</p>
        <commentItem></commentItem>
      </div>
    </div>
    <template v-if="is_active">
      <p
        class="notice"
        v-if="group_info.stock - group_info.sales_num > 0"
      >拼团名额剩余{{group_info.stock - group_info.sales_num}}个，请尽快开团抢购哦</p>
      <p class="notice" v-else>拼团名额已售罄，可单独购买学习哦</p>
    </template>
    <footer-btn v-if="is_active">
      <div class="btns" slot="btn">
        <div class="left-btn" :class="{'default-btn': group_info.is_join_spell}" @click="submit">
          <p class="p1">
            <icon-price size="mini"></icon-price>
            <span>{{group_info.price | toFixPrice}}</span>
          </p>
          <p>单独购买</p>
        </div>
        <div
          class="right-btn"
          @click="openSpell"
          :class="{'default-btn': group_info.stock - group_info.sales_num == 0 && !group_info.is_join_spell}"
        >
          <p class="p1">
            <icon-price size="mini"></icon-price>
            <span v-if="group_info.head_price">{{group_info.head_price | toFixPrice}}</span>
            <span v-else>{{group_info.spell_price | toFixPrice}}</span>
          </p>
          <p>{{group_info.is_join_spell ? '查看我的团':'我要开团'}}</p>
        </div>
      </div>
    </footer-btn>
    <footer-btn v-else :title="state_name[state]" @submit="submit">
      <img slot="icon" v-if="state==2" class="vip-icon" src="@/assets/images/group/course-vip.png" />
    </footer-btn>
    <!-- 分享 -->
    <coupon ref="coupon" :couponList="couponList" @setCoupon="setCoupon"></coupon>
    <!-- 如果通过分享进来的 显示返回首页按钮 -->
    <!-- <back-spell :config="{redirect:'Index',title: '返回首页'}" v-if="$route.query.share_source"></back-spell> -->
    <van-popup
      class="course-serve-popup"
      v-model="show_serve"
      closeable
      :close-icon="close_icon"
      position="bottom"
      :style="{ height: '60%' }"
    >
      <div class="pop-serve">
        <p class="pop-title">课程服务</p>
        <div class="pop-item" v-for="(item,index) in detail.service" :key="index">
          <p>{{item.name}}</p>
          <p>{{item.description}}</p>
        </div>
      </div>
    </van-popup>
    <DistributeShopShare :distribute_item="distribute_item" :dis_type="0"></DistributeShopShare>
  </div>
</template>

<script>
import commentItem from "@/components/CommentItem";
import charpter from "@/components/Charpter";
import courseItem from "@/components/CourseItem";
import coupon from "@/components/Coupon";
import group from "@/components/group/GroupList";
import groupInfo from "@/components/group/GroupInfo";
import DistributeShopShare from "@/components/distribute/ShopShare";
export default {
  name: "CourseDetail",
  components: {
    commentItem,
    charpter,
    courseItem,
    coupon,
    group,
    groupInfo,
    DistributeShopShare
  },
  data() {
    return {
      top: 0,
      id: "",
      detail: {
        service: []
      },
      teachers: [],
      couponList: [],
      courses: [],
      list: [],
      qrimg: "",
      active: "",
      state: 0,
      state_name: ["立即报名", "立即学习", "加入学习"],
      max_price: 0,
      group_list: [],
      group_info: {},
      is_active: 0,
      fix: false,
      show_serve: false,
      close_icon: require("@/assets/images/icon-course-serve-close.png"),
      distribute_item: null
    };
  },
  methods: {
    async getDetail() {
      let data = await this.$http.get(
        `/api/app/courseInfo/basis_id=${this.id}`
      );
      this.distribute_item = data.distribute_item;
      this.detail = data.info;
      this.couponList = data.couponList;
      this.teachers = data.teachers;
      if (this.couponList.length) {
        let max_price = 0;
        data.couponList.forEach(item => {
          if (max_price < item.discounted_price) {
            max_price = item.discounted_price;
          }
        });
        this.max_price = max_price;
      }
      if (data.info.course_type == 9) {
        this.getSysCourse();
      }
      if (data.info.is_buy || data.info.is_join_study) {
        this.state = 1; //立即学习
        if (data.info.is_join_study == 0) {
          this.state = 2; //加入学习
        }
      } else {
        this.state = 0; //立即报名
      }
      // 课程详情分享
      this.$store.dispatch("setShare", {
        share_type: 2,
        route: this.$route,
        web_title: data.info.title,
        web_description: "我在这里发现了一门课程，快来看看吧",
        mobile_logo: data.info.cover_img
      });
      this.getGroupInfo();
    },
    /**
     * 拼团信息
     *  */
    async getGroupInfo() {
      let group_info = await this.$http.get(
        `/api/app/spellGroupInfo/${this.id}/course`
      );
      if (!Array.isArray(group_info)) {
        // 该用户已经加入拼团，并且团成 / 已经单独购买过， 不显示拼团信息
        if (
          (group_info.is_join_spell && group_info.group_status == 1) ||
          (this.detail.is_buy == 1 && !group_info.is_join_spell)
        ) {
          this.is_active = 0;
        } else {
          this.is_active = 1;
          let data = await this.$http.get(
            `/api/app/spellGroup/${group_info.id}`
          );
          data.list.forEach(item => {
            item.surpTime = item.end_time - Date.parse(new Date()) / 1000;
          });
          this.group_list = data.list;
        }
      }
      group_info.surp_time =
        group_info.end_time - Date.parse(new Date()) / 1000;
      this.group_info = group_info;
    },
    async getCharpter() {
      this.list = await this.$http.post(`/api/app/courseChapter`, {
        id: this.id
      });
    },
    getSysCourse() {
      this.$http.post(`/api/app/sysCourseList`, { id: this.id }).then(res => {
        this.courses = res;
      });
    },
    getCoupon() {
      this.$refs.coupon.showModel();
    },
    setCoupon(index) {
      this.couponList[index].is_can_get = 0;
    },
    goVip() {
      this.$router.push({
        name: "Vip"
      });
    },
    goTeacher(id) {
      this.$router.push({
        name: "Teacher",
        query: {
          id: id
        }
      });
    },
    /**
     * 滑动导航
     *  */
    handleScroll() {
      this.top =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let a_h = window.$("#tro").offset().top - 240;
      let l_h = window.$("#list").offset().top - 240;
      let r_h = 0;
      if (this.detail.course_type != 9)
        r_h = window.$("#com").offset().top - 240;
      let n_h = window.$("#nav-head").offset().top;
      if (this.top > n_h) {
        this.fix = true;
      } else {
        this.fix = false;
      }
      if (this.detail.course_type != 9) {
        if (this.top <= a_h) {
          this.active = "tro";
        } else if (this.top <= l_h) {
          this.active = "list";
        } else if (this.top >= r_h) {
          this.active = "com";
        }
      } else {
        if (this.top <= l_h) {
          this.active = "list";
        } else if (this.top >= a_h) {
          this.active = "tro";
        }
      }
    },
    scrollTo(name) {
      this.active = name;
      let h = window.$(`#${name}`).offset().top - 240;
      window.$("html,body").animate({ scrollTop: h }, 500);
    },
    /**
     * 开团
     *  */
    async openSpell() {
      if (this.$pub.checkLogin(true, "push")) {
        if (this.group_info.is_join_spell) {
          // 查看我的团
          this.$router.push({
            name: "GroupDetail",
            query: {
              group_id: this.group_info.group_id
            }
          });
        } else {
          let flag = await this.$store.dispatch("CheckSpell", {
            spell_id: this.group_info.id
          });
          if (flag) {
            this.$router.push({
              name: "Purchase",
              query: {
                id: this.$route.query.id,
                type: this.detail.course_type,
                spell_id: this.group_info.id,
                group_id: 0
              }
            });
          }
        }
      }
    },
    async submit() {
      if (this.group_info.is_join_spell && this.group_info.group_status != 1) {
        return;
      }
      if (this.$pub.checkLogin(true, "push")) {
        // 已购买被移除的课程再次加入学习
        if (this.state == 1) {
          if (this.detail.is_join_study == 0) {
            await this.$http.post("/api/app/joinStudy", {
              course_basis_id: this.id,
              order_id: 0,
              join_from: 3,
              course_type: this.detail.course_type
            });
          }
          // 立即学习
          this.$router.push({
            name: "MyStudyDetail",
            query: {
              course_id:
                this.detail.course_type == 9 ? this.courses[0].id : this.id
            }
          });
          return;
        }
        if (
          this.detail.store_num > 0 &&
          this.detail.store_num < 999999 &&
          this.detail.stock == 0
        ) {
          this.$toast({
            message: "你来晚了哦,名额已经没有了",
            duration: 1500
          });
          return;
        }
        this.$router.push({
          name: "Purchase",
          query: {
            id: this.id,
            type: this.detail.course_type
          }
        });
      }
    },
    init() {
      this.id = this.$route.query.id;
      this.getDetail();
      this.getCharpter();
    },
    openServer() {
      this.show_serve = true;
    }
  },
  async created() {
    if (this.$route.query.distribute_uid) {
      await this.$http.get(
        "/api/distribute/item/bind/" + this.$route.query.distribute_uid
      );
    }
    this.init();
  },
  watch: {
    $route(val, old) {
      if (val.query.id != old.query.id) {
        this.init();
      }
    }
  },
  mounted() {
    setTimeout(() => {
      window.addEventListener("scroll", this.handleScroll);
    }, 300);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style lang="scss" scoped>
/deep/ .btns {
  width: 688px;
  height: 74px;
  margin: 13px auto;
  border-radius: 37px;
  overflow: hidden;
  display: flex;
  .left-btn {
    width: 346px;
    height: 69px;
    padding-top: 5px;
    background: #ecf0ff;
    color: $theme_color;
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 32px;
      text-align: center;
    }
    .p1 {
      font-size: 26px;
    }
  }
  .right-btn {
    width: 346px;
    height: 69px;
    background: $theme_color;
    padding-top: 5px;
    color: #fff;
    p {
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      line-height: 32px;
      text-align: center;
    }
    .p1 {
      font-size: 26px;
    }
  }
  .default-btn {
    color: #8c8c8c;
    background: rgba(244, 244, 244, 1);
  }
}
.course-detail {
  width: 100%;
  overflow: hidden;
}
.vip-icon {
  position: absolute;
  right: -2px;
  top: 0;
  width: 110px;
  height: 74px;
}
.header {
  height: 88px;
  line-height: 88px;
  margin-top: 20px;
  header {
    @extend %flex-center;
    height: 88px;
    width: 100%;
    box-sizing: border-box;
    // position: fixed;
    z-index: 9;
    background: #fff;
    border-bottom: 1px solid #f0f2f5;
  }
  .fixed-sty {
    position: fixed;
    top: 0px;
  }
  .header_box {
    width: 100%;
    height: 100%;
  }
  .back {
    @extend %flex-center;
    width: 50px;
    height: 100%;
    padding-left: 20px;
    img {
      width: 18px;
      height: 32px;
    }
  }
  .h-title {
    flex: 2;
    h3 {
      text-align: center;
      font-size: 36px;
      color: #595959;
    }
    p {
      display: flex;
      justify-content: center;
      span {
        width: 33.33%;
        text-align: center;
        font-size: 30px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
      }
      span.active {
        color: #4169ff;
        font-weight: 500;
        font-size: 30px;
      }
    }
  }

  .right-tabs {
    width: 60px;
    display: flex;
    align-items: center;
    height: 100%;
    box-sizing: border-box;
    & span {
      &.cao {
        width: 40px;
        height: 44px;
        padding: 10px;
        img {
          width: 30px;
          height: 34px;
          margin-top: 5px;
          display: block;
        }
      }
    }
  }
}
.cd-body {
  background: #f0f2f5;
  padding-bottom: 100px;
  box-sizing: border-box;
  min-height: 92vh;
}
.cd-cover {
  height: 440px;
  display: block;
}
.cd-info {
  padding: 30px;
  background: #fff;
  position: relative;
  .info-title {
    font-size: 32px;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    padding-right: 80px;
    line-height: 46px;
  }
  .info-price {
    font-size: 34px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(238, 31, 31, 1);
    line-height: 64px;
    span {
      font-size: 24px;
    }
    /deep/ .price-ico {
      width: 16px;
      margin: 0 8px;
    }
    .underline {
      font-size: 26px;
      color: #999;
      text-decoration: line-through;
    }
  }
  .cd-free {
    color: $theme_color;
  }
  .info-com {
    font-size: 28px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.45);
    line-height: 60px;
    font {
      &:nth-child(2) {
        padding-left: 12px;
      }
    }
  }
}
.cd-actives {
  padding: 30px 30px 10px 30px;
  margin-top: 30px;
  background: #fff;
  section {
    .actives-item {
      display: flex;
      align-items: center;
      padding-bottom: 20px;
      /deep/ .icon-price {
        margin-left: 5px;
      }
      > span {
        &:first-child {
          width: 72px;
          font-size: 20px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #8c8c8c;
          margin-right: 8px;
        }
        &:nth-child(2) {
          flex: 1;
          font-size: 24px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(89, 89, 89, 1);
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          /deep/ .icon-price {
            color: #ea7a2f;
          }
          i {
            color: #ea7a2f;
          }
        }
      }
      font {
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        padding-right: 24px;
        background: url("../../assets/images/icon-go.png") no-repeat right
          center;
        background-size: 16px 28px;
      }
    }
  }
}
.notice {
  height: 54px;
  line-height: 54px;
  position: fixed;
  bottom: 100px;
  left: 0;
  right: 0;
  background: #f4f4f4;
  font-size: 26px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(140, 140, 140, 1);
  text-align: center;
}
.cd-title {
  font-size: 30px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(38, 38, 38, 1);
  padding-top: 20px;
}
.com-style {
  margin-top: 20px;
  background: #fff;
  padding: 10px 20px;
}
.cd-teachers {
  ul {
    display: flex;
    flex-wrap: wrap;
    padding: 20px 0;
    li {
      padding: 20px 0;
      width: 20%;
      height: 180px;
      display: flex;
      align-items: center;
      flex-direction: column;
      box-sizing: border-box;
      img {
        width: 78px;
        height: 78px;
        border-radius: 50%;
      }
      span {
        width: 100%;
        box-sizing: border-box;
        padding: 16px 6px 0;
        padding-top: 16px;
        font-size: 24px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
  }
}
.cd-tro {
  background: #fff;
  padding: 10px 20px;
  .cd-details {
    font-size: 28px;
    padding: 30px 10px;
    line-height: 36px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    /deep/ p {
      width: 100%;
    }
    /deep/ img {
      width: 100% !important;
      height: auto !important;
      display: block;
      border: none;
    }
    /deep/ video {
      width: 100%;
    }
  }
}
.course-serve-popup {
  border-radius: 20px 20px 0 0;
  /deep/ .van-icon__image {
    width: 32px;
    height: 32px;
  }
  .pop-title {
    height: 100px;
    line-height: 100px;
    font-size: 34px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(38, 38, 38, 1);
    text-align: center;
  }
  .pop-item {
    padding: 25px 30px;
    p {
      &:nth-child(1) {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(38, 38, 38, 1);
        line-height: 40px;
        padding-bottom: 16px;
      }
      &:nth-child(2) {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(91, 96, 102, 1);
        line-height: 40px;
      }
    }
  }
}
</style>
